import React, { useState } from 'react';
import {Button, CircularProgress, Container, Grid, TextField} from "@material-ui/core";
import styled from 'styled-components';
import Layout from '../Shared/Layout';
import { Inertia } from '@inertiajs/inertia';
import { useForm } from '@inertiajs/inertia-react';
import { Trans } from "../utils/i18n";

const Wrapper = styled.div`
  width: 100%;
`;

const Card = styled.div`
padding: 50px;
  color: ${props => props.theme.white};
  background-color: ${props => props.theme.primary};
  text-align: center;
`;

const Title = styled.h2`
  font-size: 40px;
  margin: 0 0 40px;
`;

const InputTextField = styled(TextField)`
  input {
    background: ${props => props.theme.white};
    border-radius: 4px 4px 0 0;
  }
`;

const ButtonWrapper = styled.div`
`;

export default function NewPassword({ email, token }) {
    const { data, setData, post, processing, errors } = useForm({
        token: token,
        email: email,
        password: '',
        password_confirmation: '',
    });

  const handleSubmit = async e => {
    e.preventDefault();
    const data = { 'email': e.target[0].value };

      post(route('password.update'));
  }

  return (
    <Wrapper>
      <Container maxWidth="lg">
        <Grid container justify="center">
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <Title><Trans i18nKey="newPassword.forgotPassword">Forgot Password</Trans></Title>
              <form onSubmit={handleSubmit}>
                <input hidden value={token} name={'token'}/>
                <InputTextField id="email" label={<Trans i18nKey="newPassword.email">E-Mail</Trans>} value={data.email} onChange={e => setData('email', e.target.value)} name="email" type="email" required error={errors.email} variant="filled" style={{ marginBottom: '25px' }} />
                <InputTextField id="password" label={<Trans i18nKey="newPassword.password">Password</Trans>} name="password" value={data.password} onChange={e => setData('password', e.target.value)} type="password" required error={errors.password} variant="filled" style={{ marginBottom: '25px' }} />
                <InputTextField id="password_confirmation" label={<Trans i18nKey="newPassword.confirmPassword">Confirm Password</Trans>} name="password_confirmation" value={data.password_confirmation} onChange={e => setData('password_confirmation', e.target.value)} type="password" required error={errors.password_confirmation} variant="filled" style={{ marginBottom: '25px' }} />
                <ButtonWrapper>
                  <Button type="submit" variant="contained" color="secondary">
                      {
                          !processing && <Trans i18nKey="newPassword.resetPassword">Reset Password</Trans>
                      }
                      {
                          processing && <CircularProgress style={{ height: 28, width: 28 }}/>
                      }
                  </Button>
                </ButtonWrapper>
                  {
                      errors && errors.email && <p>{ errors.email }</p>
                  }
                  {
                      errors && errors.password && <p>{ errors.password }</p>
                  }
              </form>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  )
}

NewPassword.layout = page => <Layout children={page} />;
